<template>
    <!-- Email input field -->
    <div :class="emailInputClass">
        <label
            class="input__label"
            :class="{ 'required-input': mandatory }"
            for="email-address"
            v-text="label || $t('ACCOUNT_FORM_EMAIL')"/>
        <input
            id="email-address"
            name="email"
            autocomplete="email"
            autocapitalize="off"
            type="email"
            class="input__field"
            v-model.trim="email">

        <!-- Validation -->
        <p class="input__message"
           v-if="message"
           v-text="message"/>
        <p class="input__message"
           v-else-if="$t(errorHandler.has('email'))"
           v-text="$t(errorHandler.get('email'))"/>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import EmailService from '@/services/users/EmailService';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';

let emailService = new EmailService();
export default {
    name: 'EmailAddressField',
    props: {
        value: {
            default: null,
            type: String,
        },
        label: {
            default: null,
            type: String,
        },
        shouldValidate: {
            default: false,
            type: Boolean,
        },
        message: {
            required: false,
            type: String,
            default: null,
        },
        isValid: {
            default: true,
            type: Boolean,
        },
        mandatory: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            email: null,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        emailInputClass() {
            if (this.value === null && this.isEmailValid === true) {
                return 'input';
            }

            return this.isEmailValid ? 'input input--success' : 'input input--invalid';
        },

        isEmailValid() {
            return !this.errorHandler.has('email') && this.isValid;
        },
    },
    methods: {
        /**
         * Handle validating the email with the API.
         *
         * @param {string} value
         *
         * @return void
         */
        validateEmail(value) {
            emailService.isEmailAvailable(value)
                .then(() => this.errorHandler.reset())
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
    },
    watch: {
        email: debounce(function(value) {
            this.$emit('input', value);
            this.shouldValidate ? this.validateEmail(value) : false;
        }, 500),
        value: {
            immediate: true,
            handler(value) {
                this.email = value;
            },
        },
    },
};
</script>
